import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Globe, BookOpen, Briefcase } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';

const FacultyPage: React.FC = () => {
  const faculty = [
    // 1분과: AI 윤리·신뢰성·책임성 분과
    {
      id: 1,
      name: "김형종",
      title: "1분과 책임교수",
      department: "정보보호학부",
      specialization: "AI 윤리, 정보보호, 신뢰성",
      email: "kimhj@swu.ac.kr",
      website: "https://kimhj-lab.swu.ac.kr",
      bio: "AI 윤리와 정보보호 분야의 전문가로, AI 기술의 윤리적·책임적 활용을 위한 기준과 가이드라인 수립에 기여하고 있습니다.",
      division: "1분과: AI 윤리·신뢰성·책임성 분과",
      researchAreas: ["AI 윤리", "정보보호", "신뢰성", "책임성"]
    },
    {
      id: 2,
      name: "이병걸",
      title: "1분과 참여교수",
      department: "데이터사이언스학과",
      specialization: "데이터 분석, AI 편향성",
      email: "leebg@swu.ac.kr",
      website: "https://leebg-lab.swu.ac.kr",
      bio: "데이터사이언스 분야의 전문가로, AI 알고리즘의 편향 검출과 공정성 분석 연구를 수행하고 있습니다.",
      division: "1분과: AI 윤리·신뢰성·책임성 분과",
      researchAreas: ["데이터 분석", "AI 편향성", "공정성", "설명가능성"]
    },
    {
      id: 3,
      name: "박남춘",
      title: "1분과 참여교수",
      department: "산업디자인학과",
      specialization: "사용자 경험, 접근성 디자인",
      email: "parknc@swu.ac.kr",
      website: "https://parknc-lab.swu.ac.kr",
      bio: "산업디자인 분야의 전문가로, 사회적 약자를 위한 접근성 디자인과 사용자 경험 연구를 수행하고 있습니다.",
      division: "1분과: AI 윤리·신뢰성·책임성 분과",
      researchAreas: ["사용자 경험", "접근성 디자인", "사회적 약자", "인터페이스"]
    },
    
    // 2분과: AI 융합교육 개발 분과
    {
      id: 4,
      name: "이종태",
      title: "2분과 책임교수",
      department: "경영학과",
      specialization: "경영학, AI 융합교육",
      email: "leejt@swu.ac.kr",
      website: "https://leejt-lab.swu.ac.kr",
      bio: "경영학과 AI 융합교육 분야의 전문가로, AX(AI Transformation) 시대 인재 양성을 위한 융합형 교과목 개발을 주도하고 있습니다.",
      division: "2분과: AI 융합교육 개발 분과",
      researchAreas: ["경영학", "AI 융합교육", "AX 교육", "교과목 개발"]
    },
    {
      id: 5,
      name: "이창석",
      title: "2분과 참여교수",
      department: "화학과",
      specialization: "화학, 자연과학",
      email: "leecs@swu.ac.kr",
      website: "https://leecs-lab.swu.ac.kr",
      bio: "화학 분야의 전문가로, 자연과학 영역에서의 AI 융합 교육 프로그램 개발에 참여하고 있습니다.",
      division: "2분과: AI 융합교육 개발 분과",
      researchAreas: ["화학", "자연과학", "AI 융합", "교육 프로그램"]
    },
    {
      id: 6,
      name: "김수연",
      title: "2분과 참여교수",
      department: "국어국문학과",
      specialization: "국어국문학, 인문학",
      email: "kimsy@swu.ac.kr",
      website: "https://kimsy-lab.swu.ac.kr",
      bio: "국어국문학 분야의 전문가로, 인문학 영역에서의 AI 융합 교육과 언어 처리 연구를 수행하고 있습니다.",
      division: "2분과: AI 융합교육 개발 분과",
      researchAreas: ["국어국문학", "인문학", "언어 처리", "AI 융합"]
    },
    {
      id: 7,
      name: "김평호",
      title: "2분과 참여교수",
      department: "심리인지과학학부",
      specialization: "심리학, 인지과학",
      email: "kimph@swu.ac.kr",
      website: "https://kimph-lab.swu.ac.kr",
      bio: "심리인지과학 분야의 전문가로, 인간의 인지 과정과 AI 시스템의 상호작용 연구를 수행하고 있습니다.",
      division: "2분과: AI 융합교육 개발 분과",
      researchAreas: ["심리학", "인지과학", "인간-AI 상호작용", "인지 과정"]
    },
    {
      id: 8,
      name: "김민서",
      title: "2분과 참여교수",
      department: "교양대학",
      specialization: "교양교육, AI 리터러시",
      email: "kimms@swu.ac.kr",
      website: "https://kimms-lab.swu.ac.kr",
      bio: "교양교육 분야의 전문가로, AI 리터러시 향상을 위한 교양 교육 프로그램 개발에 참여하고 있습니다.",
      division: "2분과: AI 융합교육 개발 분과",
      researchAreas: ["교양교육", "AI 리터러시", "교육 프로그램", "기초 교육"]
    },
    
    // 3분과: 지산학 연계 분과
    {
      id: 9,
      name: "박후린",
      title: "3분과 책임교수",
      department: "지능정보보호학부",
      specialization: "지능정보보호, 산학연계",
      email: "parkhr@swu.ac.kr",
      website: "https://parkhr-lab.swu.ac.kr",
      bio: "지능정보보호 분야의 전문가로, 지역-산업-학계 협력을 통한 현장 중심의 인간-AI 협력 연구 모델 구축을 주도하고 있습니다.",
      division: "3분과: 지산학 연계 분과",
      researchAreas: ["지능정보보호", "산학연계", "현장 연구", "협력 모델"]
    },
    {
      id: 10,
      name: "오준형",
      title: "3분과 참여교수",
      department: "지능정보보호학부",
      specialization: "정보보호, 데이터 분석",
      email: "ohjh@swu.ac.kr",
      website: "https://ohjh-lab.swu.ac.kr",
      bio: "지능정보보호 분야의 전문가로, 산업 현장의 데이터 분석과 예측 모델링 연구를 수행하고 있습니다.",
      division: "3분과: 지산학 연계 분과",
      researchAreas: ["정보보호", "데이터 분석", "예측 모델링", "산업 응용"]
    },
    {
      id: 11,
      name: "최은정",
      title: "3분과 참여교수",
      department: "지능정보보호학부",
      specialization: "지능정보보호, 생성형 AI",
      email: "choiej@swu.ac.kr",
      website: "https://choiej-lab.swu.ac.kr",
      bio: "지능정보보호 분야의 전문가로, 생성형 AI 기술의 산업 현장 적용과 보안 연구를 수행하고 있습니다.",
      division: "3분과: 지산학 연계 분과",
      researchAreas: ["지능정보보호", "생성형 AI", "산업 적용", "보안"]
    },
    {
      id: 12,
      name: "김예리",
      title: "3분과 참여교수",
      department: "데이터사이언스학과",
      specialization: "데이터사이언스, AI 응용",
      email: "kimyr@swu.ac.kr",
      website: "https://kimyr-lab.swu.ac.kr",
      bio: "데이터사이언스 분야의 전문가로, 지역 산업 특성을 반영한 AI 기술의 현장 적용 연구를 수행하고 있습니다.",
      division: "3분과: 지산학 연계 분과",
      researchAreas: ["데이터사이언스", "AI 응용", "지역 산업", "현장 적용"]
    },
    
    // 4분과: AI 교수학습 분과
    {
      id: 13,
      name: "서윤경",
      title: "4분과 책임교수",
      department: "교수학습센터",
      specialization: "교수학습, 교육공학",
      email: "seoyk@swu.ac.kr",
      website: "https://seoyk-lab.swu.ac.kr",
      bio: "교수학습 분야의 전문가로, AI를 협력적 행위자로 재정립하여 인간-AI 공동지성 기반의 교수학습 패러다임 구축을 주도하고 있습니다.",
      division: "4분과: AI 교수학습 분과",
      researchAreas: ["교수학습", "교육공학", "AI 협력", "공동지성"]
    },
    {
      id: 14,
      name: "장윤재",
      title: "4분과 참여교수",
      department: "언론영상학부",
      specialization: "미디어, 언론영상",
      email: "jangyj@swu.ac.kr",
      website: "https://jangyj-lab.swu.ac.kr",
      bio: "언론영상 분야의 전문가로, 미디어 영역에서의 인간-AI 협력 양상과 교육 모델 연구를 수행하고 있습니다.",
      division: "4분과: AI 교수학습 분과",
      researchAreas: ["미디어", "언론영상", "인간-AI 협력", "교육 모델"]
    },
    {
      id: 15,
      name: "윤이수",
      title: "4분과 참여교수",
      department: "바이오헬스융합학과",
      specialization: "바이오헬스, 뇌과학",
      email: "yoones@swu.ac.kr",
      website: "https://yoones-lab.swu.ac.kr",
      bio: "바이오헬스융합 분야의 전문가로, 뇌과학과 바이오헬스 영역에서의 인간-AI 협력 연구를 수행하고 있습니다.",
      division: "4분과: AI 교수학습 분과",
      researchAreas: ["바이오헬스", "뇌과학", "인간-AI 협력", "융합 연구"]
    },
    {
      id: 16,
      name: "이수지",
      title: "4분과 참여교수",
      department: "인지심리과학학부",
      specialization: "인지심리, 심리과학",
      email: "leesj@swu.ac.kr",
      website: "https://leesj-lab.swu.ac.kr",
      bio: "인지심리과학 분야의 전문가로, 인간의 인지적 협력과 AI 시스템의 상호작용 연구를 수행하고 있습니다.",
      division: "4분과: AI 교수학습 분과",
      researchAreas: ["인지심리", "심리과학", "인지적 협력", "AI 상호작용"]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="h-16" />
      <Breadcrumb />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            참여 교수진
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            인간-AI 협력 연구센터에 참여하는 다양한 분야의 전문가들을 소개합니다.
          </p>
        </div>

        {/* Faculty Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {faculty.map((member) => (
            <div key={member.id} className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="p-6">
                {/* Profile Header */}
                <div className="text-center mb-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                  <p className="text-teal-600 font-medium mb-2">{member.title}</p>
                  <p className="text-gray-600 text-sm mb-2">{member.department}</p>
                  <p className="text-xs text-teal-500 font-medium">{member.division}</p>
                </div>

                {/* Specialization */}
                <div className="mb-4">
                  <div className="flex items-center mb-2">
                    <Briefcase className="h-4 w-4 text-gray-500 mr-2" />
                    <span className="text-sm font-medium text-gray-700">전문 분야</span>
                  </div>
                  <p className="text-sm text-gray-600">{member.specialization}</p>
                </div>

                {/* Bio */}
                <div className="mb-4">
                  <p className="text-sm text-gray-600 line-clamp-3">{member.bio}</p>
                </div>

                {/* Research Areas */}
                <div className="mb-4">
                  <div className="flex items-center mb-2">
                    <BookOpen className="h-4 w-4 text-gray-500 mr-2" />
                    <span className="text-sm font-medium text-gray-700">연구 영역</span>
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {member.researchAreas.map((area, index) => (
                      <span key={index} className="inline-block bg-teal-50/60 text-teal-700 text-xs px-2 py-1 rounded">
                        {area}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Contact */}
                <div className="flex space-x-3">
                  <a 
                    href={`mailto:${member.email}`}
                    className="flex-1 inline-flex items-center justify-center px-3 py-2 bg-teal-500 text-white text-sm font-medium rounded hover:bg-teal-600 transition-colors"
                  >
                    <Mail className="h-4 w-4 mr-1" />
                    이메일
                  </a>
                  <a 
                    href={member.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 inline-flex items-center justify-center px-3 py-2 bg-gray-100 text-gray-700 text-sm font-medium rounded hover:bg-gray-200 transition-colors"
                  >
                    <Globe className="h-4 w-4 mr-1" />
                    웹사이트
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>


        {/* Call to Action */}
        <section className="text-center bg-teal-50/60 rounded-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            연구 협력을 원하시나요?
          </h2>
          <p className="text-lg text-gray-600 mb-6">
            인간-AI 협력 연구에 관심이 있으시다면 언제든지 연락해주세요.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/about" 
              className="inline-flex items-center px-6 py-3 bg-teal-500 text-white font-medium rounded-lg hover:bg-teal-600 transition-colors"
            >
              센터 소개 보기
            </Link>
            <Link 
              to="/divisions" 
              className="inline-flex items-center px-6 py-3 bg-white text-teal-600 font-medium rounded-lg border border-teal-500 hover:bg-teal-50/60 transition-colors"
            >
              연구 분과 알아보기
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default FacultyPage;
